import { COMBINED_PAGES } from 'scenes/Users/AdminUsers/constants';

const skipDuplicatedNames = (path, pageTitle) => {
  return path.includes(pageTitle) ||
    pageTitle === 'Partner Management (PCs, BPs and Affiliates)'
    ? pageTitle
    : [...path, pageTitle].join(' / ');
};

export const mapPageToOptions = ({ id, path = [], title }) => {
  const groupedPage = COMBINED_PAGES.find(page => page.id === id);
  const pageTitle = groupedPage ? groupedPage.name : title;
  const pageName = path.length
    ? skipDuplicatedNames(path, pageTitle)
    : pageTitle;

  return {
    id,
    name: pageName,
  };
};
